import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

const Layout = ({ children, meta }) => {
  const router = useRouter();
  const DEFAULT_SEO = {
    title: "Drummoyne Rowing Club",
    description:
      meta.description ||
      "Drummoyne Rowing Club is a community-based club located on Henley Marine Drive, Drummoyne.",
    keywords: "marketplace",
    openGraph: {
      type: "website",
      locale: "en_IE",
      url: `${process.env.SITE_URL}${router.asPath}`,
      title: "Drummoyne Rowing Club",
      description:
        meta.description ||
        "Drummoyne Rowing Club is a community-based club located on Henley Marine Drive, Drummoyne.",

      site_name: "Drummoyne Rowing Club",
      images: [
        {
          url: `${process.env.SITE_URL}/assets/home/top-logo.png`,
          width: 164,
          height: 46,
          alt: "drummoyne-rowing-club",
        },
      ],
    },
  };

  return (
    <>
      <NextSeo {...DEFAULT_SEO} />
      <>{children}</>
    </>
  );
};

export default Layout;
